import React from "react";
import { connect } from "react-redux";
import { getters, actions } from "EventLight/Sessions/AddSessionModal/model";
import { getParentSessionName } from "../selectors";

import Body from "./Body";
import Footer from "./Footer";
import StyleWrapper from "components/Global/Modal/Layout/StyleWrapper";
import Loading from "ui-kit/Loading";
import MediaContentModal from "ui-kit/MediaContentModal/View";
import Header from "./Header";
import {
  CONTENT_MODAL_ID,
  SUBSESSIONS_STEPS,
  FROM_SESSION_PAGE
} from "../constants";
import { Div, LeftIcon } from "components/Base";
import LinkSessionsAsSubsessions from "./LinkSessionsAsSubsessions";
import ModalWrapper from "components/Global/Modal/Wrappers/Black";
import { noop } from "lodash";

import UnsavedChangesModal from "./UnsavedChangesModal";

const decorate = connect(
  state => ({
    loading: getters.loading(state),
    isSubsession: getters.isSubsession(state),
    parentSessionName: getParentSessionName(state),
    data: getters.data(state),
    convertSessionstoSubsessions: getters.convertSessionstoSubsessions(state),
    activeSubsessionsIndex: getters.activeSubsessionsIndex(state),
    showSessionModal: getters.showSessionModal(state),
    sessionId: getters.sessionId(state),
    returnToScene: getters.returnToScene(state),
    hasUnSavedChangesModal: getters.hasUnSavedChangesModal(state)
  }),
  {
    goToParentSession: actions.goToParentSession,
    showAddSessionModal: actions.showAddSessionModal,
    hideShowSessionModal: () => actions.setShowSessionModal(false)
  }
);

const Layout = ({
  handlers,
  loading,
  sessionId,
  isSubsession,
  goToParentSession,
  parentSessionName,
  data,
  convertSessionstoSubsessions,
  activeSubsessionsIndex = 0,
  showSessionModal = false,
  hideShowSessionModal = noop,
  returnToScene = null,
  hasUnSavedChangesModal = false
}) => {
  if (!showSessionModal) return null;
  return (
    <ModalWrapper>
      <StyleWrapper
        hideHeader={false}
        bodyStyles={{ padding: 0 }}
        containerStyles={{
          overflowY: "hidden",
          marginTop: 0,
          alignItems: "flex-start"
        }} // 728
        headerStyles={{
          backgroundColor: isSubsession ? "#1e95d8" : undefined,
          height:
            isSubsession || (!isSubsession && sessionId) ? "76px" : undefined
        }}
        heading={
          <Div display="column.center" ml={1}>
            {isSubsession &&
            !convertSessionstoSubsessions &&
            returnToScene !== FROM_SESSION_PAGE ? (
              <Div
                display="row.flex-start.center"
                fs={2}
                mb={1}
                color="white"
                onClick={goToParentSession}
              >
                <LeftIcon mr={1} color="white" sizeWFS={4} />
                Parent: {parentSessionName}
              </Div>
            ) : null}
            {sessionId && !convertSessionstoSubsessions && (
              <Div>Edit {isSubsession ? "Subsession" : "Session"}</Div>
            )}
            {!sessionId && !convertSessionstoSubsessions && (
              <Div>Add {isSubsession ? "Subsession" : "Session"}</Div>
            )}
            {convertSessionstoSubsessions && (
              <Div>{SUBSESSIONS_STEPS[activeSubsessionsIndex]}</Div>
            )}
            {!isSubsession && sessionId && !convertSessionstoSubsessions ? (
              <Div display="row.flex-start.center" fs={2} mt={1} color="white">
                {data.title}
              </Div>
            ) : null}
          </Div>
        }
        hideModal={hideShowSessionModal}
        width={1000}
      >
        {!convertSessionstoSubsessions ? (
          <>
            <Header hideModal={hideShowSessionModal} />
            {loading ? <Loading /> : <Body handlers={handlers} />}
            <Footer handlers={handlers} />
            <MediaContentModal instanceId={CONTENT_MODAL_ID} />
          </>
        ) : (
          <LinkSessionsAsSubsessions handlers={handlers} />
        )}
        {hasUnSavedChangesModal && <UnsavedChangesModal />}
      </StyleWrapper>
    </ModalWrapper>
  );
};

export default decorate(Layout);
